import { useState, useEffect } from "react";
import "./AppSidebar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { APP_MENUS, selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { Workspace } from "winslow-core";
import { apiCreateWorkspaceHRIS, apiCreateWorkspaceTestHRIS, apiGetWorkspace } from "../../../api";
import { Button } from "../../../ds2/components";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import config from "environment";

const NOT_PROD = config.environment !== "production";

type AppSidebarProps = {

}

export const AppSidebar = ({} : AppSidebarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates)

    const [workspace, setWorkspace] = useState<Workspace | null>( null);
    const [testSystem, setTestSystem] = useState<string>("");

    useEffect(() => {
        const workspaceId = storeUser?.currentWorkspaceId;

        (async () => {
            const workspace = await apiGetWorkspace(workspaceId);
            setWorkspace(workspace);
        })();

    }, [storeUser?.currentWorkspaceId]);

    const createNativeHRIS =  async () => {
        const workspace = await apiCreateWorkspaceHRIS(storeUser?.currentWorkspaceId);

        if (!workspace) {
            toast("Error creating HRIS", toastFail);
            return;
        }

        setWorkspace(workspace);
    }

    const createTestHRIS = async () => {
        const workspace = await apiCreateWorkspaceTestHRIS(storeUser?.currentWorkspaceId, testSystem);

        if (!workspace) {
            toast("Error creating test HRIS", toastFail);
            return;
        }

        setWorkspace(workspace);
    }

    const thirdPartyHRIS = workspace?.mergeIntegration || workspace?.apiDeckIntegration; 

    return (
        <div className="app-sidebar">
            {workspace?.hasNativeHRIS && !thirdPartyHRIS && 
                <>
                    <div className="app-sidebar-section">
                        Manage
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEES}));
                            navigate("/app/employee-records")
                        }}
                    >
                        Employees
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_NEW}));
                            navigate("/app/employee-records/new")
                        }}
                    >
                        Add Employee
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.TIME_OFF}));
                            navigate("/app/time-off")
                        }}
                    >
                        Time Off
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.FLATTEN}));
                            navigate("/app/employee-records/flatten")
                        }}
                    >
                        Flatten
                    </div>

                    {/* <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.DOCUMENTS}));
                            navigate("/app/documents")
                        }}
                    >
                        Documents
                    </div> */}

                    <div className="app-sidebar-section">
                        Admin
                    </div>
                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.CUSTOM_PROPERTIES}));
                            navigate("/app/custom-properties/")
                        }}
                    >
                        Customize Properties
                    </div>

                    <div className="app-sidebar-section">
                        You
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.TIME_OFF}));
                            navigate("/app/employee/time-off")
                        }}
                    >
                        Time Off
                    </div>

                    <div 
                        className="app-sidebar-item"
                        onClick={() => {
                            dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_CALENDAR}));
                            navigate("/app/employee/calendar")
                        }}
                    >
                        Calendar
                    </div>

                </>
            }
            {workspace && !workspace?.hasNativeHRIS && 
                <>
                    {!thirdPartyHRIS && 
                        <div 
                            className="app-sidebar-section" 
                            style={{display: "flex", gap: "10px", flexDirection: "column"}}
                        >
                            <Button
                                variant="primary"
                                onClick={createNativeHRIS}
                                label="Create HRIS"
                            />

                            {NOT_PROD && 
                                <> 
                                    <Button
                                        variant="primary"
                                        onClick={createTestHRIS}
                                        label="Create Test HRIS"
                                    />
                                    <input type="text" placeholder="test system" onChange={(e) => setTestSystem(e.target.value)} />
                                </>
                            }
                                
                        </div>
                    }
                    {thirdPartyHRIS && 
                        <div className="app-sidebar-section">
                            You are already using a third party HRIS
                        </div>
                    }
                </>
            }
           
        </div>
    )
}